import React from 'react';

const DEFAULT_ICON_SIZE = 24;

type Props = {
  className?: string;
  w?: number;
  h?: number;
};

const GoogleIcon = ({ className, w = DEFAULT_ICON_SIZE, h = DEFAULT_ICON_SIZE }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.9999 12.1831C19.9999 11.6391 19.9559 11.0931 19.8599 10.5571H12.1599V13.6381H16.5689C16.4766 14.1331 16.2842 14.6039 16.0036 15.0219C15.723 15.4399 15.36 15.7963 14.9369 16.0691V18.0691H17.5669C19.1119 16.6751 19.9999 14.6171 19.9999 12.1831Z"
        fill="#4285F4"
      />
      <path
        d="M12.1609 19.9982C14.3619 19.9982 16.2179 19.2902 17.5709 18.0682L14.9409 16.0682C14.2089 16.5562 13.2649 16.8332 12.1639 16.8332C10.0349 16.8332 8.22992 15.4252 7.58192 13.5322H4.86792V15.5922C6.25392 18.2942 9.07492 19.9982 12.1609 19.9982Z"
        fill="#34A853"
      />
      <path
        d="M7.57994 13.5332C7.23807 12.5408 7.23807 11.4626 7.57994 10.4702V8.40918H4.86694C4.29638 9.52057 3.99878 10.7519 3.99878 12.0012C3.99878 13.2505 4.29638 14.4818 4.86694 15.5932L7.57794 13.5332H7.57994Z"
        fill="#FBBC04"
      />
      <path
        d="M12.1609 7.16618C13.3205 7.14622 14.4427 7.57632 15.2919 8.36618L17.6219 6.08218C16.1332 4.71864 14.1806 3.97407 12.1619 4.00018C9.07494 4.00018 6.25294 5.70518 4.86694 8.40918L7.57794 10.4692C8.22294 8.57418 10.0309 7.16618 12.1599 7.16618H12.1609Z"
        fill="#EA4335"
      />
    </svg>
  );
};

GoogleIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default GoogleIcon;
